// add to backend/backend/app/controllers/api/v5/write/ticker/create.rb too
export const supportedLocales = ['en', 'de', 'de-ch', 'en-gb', 'en-ie', 'en-au', 'en-nz', 'zh-tw', 'fr', 'fr-fr', 'fr-ca', 'it-it', 'nl-nl', 'el-gr', 'pt', 'pl', "ru", "lt", "et", "af", "fi", "es"] as const;
export type SupportedLocaleType = typeof supportedLocales[number] | ""
